// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iv_a bhc_sq","PhotoTitleEditForm__cancelBtn":"iv_b bhc_su bhc_st"};